import { MoneyBox } from '@apply/components';
import { useCustomPaymentAmount } from '../../../../../fields/CustomPaymentFields';

interface TotalAmountProps {
    customPaymentId: string;
    fee: number;
}

export const TotalAmount: React.FC<TotalAmountProps> = ({ customPaymentId, fee }) => {
    const [amount] = useCustomPaymentAmount(customPaymentId);
    const label = 'Total Amount ';
    return (
        <>
            <MoneyBox
                id='totalAmount'
                allowNegative={false}
                value={Number(amount) + fee}
                onChange={() => {}}
                required={true}
                label={label}
                displayChange={true}
                readOnly={true}
            />
        </>
    );
};
